import { css } from "@emotion/css";
import { $, type Properties, resolve } from "signlets";

import { classes } from "./classes";

const style = css`
  margin: 0;

  dd {
    margin: 0;
  }

  .value {
    font-size: 1.5rem;
    font-variant: tabular-nums;
  }
`;

export type MeasurementProps = {
  label: string;
  value: JSX.Element;
  unit: string;
  class?: string;
};

export const Measurement = ({
  label,
  value,
  unit,
  class: _class,
}: Properties<MeasurementProps>) => (
  <dl class={$(() => classes(style, resolve(_class)))}>
    <dt>{label}</dt>
    <dd>
      <span class="value">{value}</span> {unit}
    </dd>
  </dl>
);
